// El boton "Paga con transferencia" es <scala-cart-button> (app Scala) y renderiza
// en Shadow DOM abierto: el CSS del theme no entra. Se inyecta una hoja de estilos
// dentro del shadow para igualar la tipografia a los otros botones del drawer.
(function () {
  // Estilos inline con prioridad important: la hoja propia de Scala tambien usa
  // !important y con mayor especificidad, asi que una stylesheet inyectada no alcanza.
  const FONT_PROPS = [
    ['font-size', '13px'],
    ['font-weight', '700'],
    ['letter-spacing', '0.03em'],
    ['text-transform', 'uppercase'],
    ['line-height', '1.2'],
    ['height', '48px'],
    ['min-height', '48px'],
    ['padding', '12px 16px'],
    ['background-color', '#15803d'],
    ['border-color', '#15803d'],
    ['color', '#ffffff']
  ];

  const setProps = (el) => {
    FONT_PROPS.forEach(([prop, value]) => el.style.setProperty(prop, value, 'important'));
  };

  // Un script custom configurado dentro de la app Scala re-setea font-size:10px/height:40px
  // inline (era para el layout viejo de una fila). Guardia con patron anti-eco:
  // se desconecta el observer antes de re-aplicar para no observar las propias mutaciones.
  const guardEl = (el) => {
    if (el.dataset.collinoFontGuard === 'true') return;
    el.dataset.collinoFontGuard = 'true';
    setProps(el);
    const obs = new MutationObserver(() => {
      if (el.style.getPropertyValue('font-size') === '13px') return;
      obs.disconnect();
      setProps(el);
      obs.observe(el, { attributes: true, attributeFilter: ['style'] });
    });
    obs.observe(el, { attributes: true, attributeFilter: ['style'] });
  };

  // Colapsa el hueco reservado del boton de transferencia. Se llama al detectar
  // el boton (el intercambio hueco->boton es a cero movimiento porque miden lo
  // mismo) y tambien al terminar el barrido sin encontrarlo, para no dejar un
  // hueco permanente si la app se desinstala.
  const resolveSlot = () => {
    document.querySelectorAll('[data-cart-drawer-buttons]').forEach((c) => {
      c.classList.add('scala-resolved');
    });
  };

  const applyFix = () => {
    document.querySelectorAll('scala-cart-button').forEach((host) => {
      const root = host.shadowRoot;
      if (!root) return;
      resolveSlot();
      root.querySelectorAll('button, a, [role="button"]').forEach(guardEl);
      if (!host.dataset.collinoShadowObserved) {
        host.dataset.collinoShadowObserved = 'true';
        new MutationObserver(() => applyFix()).observe(root, { childList: true, subtree: true });
      }
    });
  };

  const start = () => {
    // El boton de Scala solo vive dentro del drawer: se observa SOLO ese subarbol
    // (no document.body) para no correr el callback en cada mutacion de la pagina.
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    if (drawer.dataset.collinoScalaInitialized === 'true') return;
    drawer.dataset.collinoScalaInitialized = 'true';
    applyFix();
    new MutationObserver(() => applyFix()).observe(drawer, { childList: true, subtree: true });
    // El shadow root de Scala se llena despues de la inyeccion sin mutar el drawer:
    // barrido de respaldo acotado (10s) y barato (querySelectorAll dentro del drawer).
    let tries = 0;
    const interval = setInterval(() => {
      tries++;
      applyFix();
      if (tries >= 10) {
        clearInterval(interval);
        // Se acabo el barrido: se colapsa el hueco pase lo que pase. Si el boton
        // llego, applyFix ya lo colapso y esto no hace nada. Si no llego, a los
        // 10s la reserva ya no tiene sentido y dejarla seria un vacio permanente.
        // Sin condicion a proposito: antes se chequeaba que el elemento NO
        // existiera, y eso dejaba afuera el caso de que exista con el shadowRoot
        // vacio (applyFix sale antes de resolver) -> hueco para siempre.
        resolveSlot();
      }
    }, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();

// Agregado directo al carrito (cross-sell del drawer + quick-add de cards).
// Delegado en document: el contenido del drawer se re-renderiza en cada update.
document.addEventListener('click', function (event) {
  const btn = event.target.closest('[data-collino-add]');
  if (!btn || btn.classList.contains('loading')) return;
  event.preventDefault();

  btn.classList.add('loading');
  btn.setAttribute('aria-disabled', 'true');

  const formData = new FormData();
  formData.append('id', btn.dataset.variantId);
  formData.append('quantity', 1);
  formData.append('sections', 'cart-drawer,cart-bubble');
  formData.append('sections_url', window.location.pathname);

  fetch(theme.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/javascript'
    },
    body: formData
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) return;

      const drawer = document.getElementById('Cart-Drawer');
      const drawerHtml = response.sections && response.sections['cart-drawer'];
      if (drawer && drawerHtml) {
        const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html').querySelector('.cart-drawer');
        if (parsed) drawer.innerHTML = parsed.innerHTML;
        if (typeof drawer.open === 'function') drawer.open();
        if (typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
      }

      const bubbleHtml = response.sections && response.sections['cart-bubble'];
      const toggle = document.getElementById('cart-drawer-toggle');
      if (toggle && bubbleHtml) {
        const parsedBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        ['.thb-secondary-area--item-count', '.thb-secondary-area--item-amount'].forEach((selector) => {
          const target = toggle.querySelector(selector);
          const source = parsedBubble.querySelector(selector);
          if (target && source) target.innerHTML = source.innerHTML;
        });
      }

      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('cart:item-added', {
          product: response.hasOwnProperty('items') ? response.items[0] : response
        });
      }
    })
    .catch((e) => console.error(e))
    .finally(() => {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
    });
});

const initCartDrawerVisualState = function (root = document) {
  const cartDrawer = root.matches?.('#Cart-Drawer') ? root : root.querySelector?.('#Cart-Drawer') || document.getElementById('Cart-Drawer');
  if (!cartDrawer) return;
  if (cartDrawer.dataset.collinoVisualInitialized === 'true') return;
  cartDrawer.dataset.collinoVisualInitialized = 'true';

  const syncVisual = () => {
    cartDrawer.classList.toggle('open', !cartDrawer.hasAttribute('inert'));
  };

  new MutationObserver(syncVisual).observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['inert']
  });
  syncVisual();

  cartDrawer.addEventListener('click', (event) => {
    if (!event.target.closest('.drawer__close-btn')) return;
    if (typeof cartDrawer.close === 'function') {
      cartDrawer.close();
    } else {
      cartDrawer.setAttribute('inert', '');
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCartDrawerVisualState());
} else {
  initCartDrawerVisualState();
}

document.addEventListener('shopify:section:load', (event) => {
  initCartDrawerVisualState(event.target);
});
